export default {"src":"/_next/static/media/Patient-CenteredCare.6a4872e9.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};